import { useEffect } from 'react'

/** The suffix every page carries, so a browser tab says what the product is. */
const SUFFIX = 'PecGoProf'

/**
 * useDocumentTitle sets the tab and, with it, what a crawler reads.
 *
 * A single-page app serves one HTML shell for every route, so without this the
 * demo, the landing page and the sign-in form all share one title. Google
 * renders the JavaScript and will pick this up; the browser tab and anything
 * pasting a link benefit immediately either way.
 *
 * The description is set alongside, because a title without a matching
 * description is half an answer to the same question.
 */
export function useDocumentTitle(title: string, description?: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = title.includes(SUFFIX) ? title : `${title} | ${SUFFIX}`

    let restoreDescription: (() => void) | undefined
    if (description) {
      const tag = document.querySelector<HTMLMetaElement>('meta[name="description"]')
      if (tag) {
        const before = tag.content
        tag.content = description
        restoreDescription = () => {
          tag.content = before
        }
      }
    }

    return () => {
      document.title = previous
      restoreDescription?.()
    }
  }, [title, description])
}
